import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../client.js';

export interface ProjectImportPayload {
  content: string;
  filename: string;
}

/**
 * Mutation-Hook für den Import eines Projekts via base64-codiertem ZIP.
 * Invalidiert nach Erfolg den projects-Query.
 */
export function useProjectImport() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (params: ProjectImportPayload) =>
      apiClient.post('/api/v1/projects/import', params),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['projects'] });
    },
  });
}
